Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../../tokens");
exports.CrimsonTheme = {
    name: 'crimson',
    appPrimaryColor: tokens_1.Crimson[100],
    appSecondaryColor: tokens_1.Grey[100],
    appFontFamily: tokens_1.Fonts.Titillium,
};
//# sourceMappingURL=CrimsonTheme.js.map